import styled from "styled-components"
import { Link } from "react-router-dom"
import { sizes } from "../01_config/Sizes"
import { colors } from "../01_config/Colors";
import { FaInstagram } from "react-icons/fa";
import { BsTwitterX } from "react-icons/bs";
import { FaFacebook } from "react-icons/fa6";



const Wrapper = styled.div`
    position: relative;
    background-color: ${colors.mainDark};
    margin: 0 ${sizes.margins_desk};
    color: white;
    text-align: center;
    border-top: solid 2px white;
    border-bottom: white solid 2px;
    z-index: 150;
    @media(max-width: 800px) {
        padding: 30px 0;
        margin: 0;
    }
`

const TopBlock = styled.div`
    display: flex;
    justify-content: center;
    gap: 10vw;
    padding: 20px;
    // background-color: red;
    @media(max-width: 800px) {
        flex-direction: column;
        align-items: center;
        gap: 30px;
        padding: 0 0 20px;
    }
`
    
const BottomBlock = styled.div`
    margin: 0px auto; 
    padding: 20px 0;
    border-top: solid white 2px;
    width: 70vw;
    @media(max-width: 800px) {
        padding: 20px 0 0;
    }
`
    
const TextBlock = styled.div`
    text-align: right;
    display: flex;
    flex-direction: column;
    line-height: 1.5;
    // background-color: green;
    &:first-of-type {
        // background-color: blue;
        width: fit-content;
        width: 180px;
    }
    &:last-of-type {
        display: block;
    }
    @media(max-width: 800px) {
        text-align: center;
    }
`

const Heading = styled.div`
    font-size: 1rem;
    font-weight: 700;
    margin-bottom: 10px; 
`

const BodyText = styled.div`
    font-size: 0.9rem;
    line-height: 1.4;
    min-height: 1.4em;
`

const LinkText = styled.a`
    font-size: 0.9rem;
    color: white;
    text-decoration: none;
    // text-decoration: underline;
    cursor: pointer;
    &:hover {
        color: lightblue;
    }
`

const OpenForm = styled.div`
    font-size: 0.9rem;
    text-decoration: none;
    color: white;
    cursor: pointer;
    &:hover {
        color: lightblue;
    }
`

const AboutUs = styled(Link)`
    font-size: 0.9rem;
    text-decoration: none;
    color: white;
    &:hover {
        color: lightblue;
    }
`

const Instagram = styled(FaInstagram)`
    cursor: pointer;
`

const X = styled(BsTwitterX)`
    margin: 0 15px;
    cursor: pointer;
`

const Facebook = styled(FaFacebook)`
    cursor: pointer;    
`

const TeachLearn = styled(Link)`
    font-family: "Rammetto One";
    font-weight: 300;
    font-size: 1.3rem;
    text-decoration: none;
    color: white;
    @media(max-width: 800px) {
        font-size: 1rem;
    }
`

export { Wrapper, TopBlock, BottomBlock, TextBlock, Heading, BodyText, LinkText, OpenForm, AboutUs, Instagram, X, Facebook, TeachLearn  }